import PropTypes from 'prop-types';
import React from 'react';
import WizardCard from 'react/shared/components/true_link/lab/form/wizard/WizardCard';
import childrenShape from 'react/shared/shapes/children';
import { goBack } from 'react/signups/card/routing/navigator';

export default function SignupWizardCard({
  children,
  className,
  showBackButton = true,
  showCancelButton,
}) {
  return (
    <WizardCard
      children={children}
      className={className}
      onBack={goBack}
      showBackButton={showBackButton}
      showCancelButton={showCancelButton}
    />
  );
}

SignupWizardCard.propTypes = {
  className: PropTypes.string,
  showBackButton: PropTypes.bool,
  showCancelButton: PropTypes.bool,
  children: childrenShape.isRequired,
};
